<template>
    <div>

        <Card :header="$t('thermalMapCategoriesShops')" overlay :loading="requestChart.getLoading()">

            <ErrorMessage :value="requestChart.getError()" />

            <template #nav>
                <div class="d-flex gap-3">
                    <b-dropdown :text="$t(`${currentChart}`)" toggle-class="caret wide">
                        <template v-for="chartType in ['impressions', 'clicks']">
                            <b-dropdown-item :key="chartType" :active="chartType === currentChart" @click="() => currentChart = chartType">{{ $t(`${chartType}`) }}</b-dropdown-item>
                        </template>
                    </b-dropdown>
                </div>
            </template>

            <div class="d-flex gap-4 flex-column">
                <Chart
                    :height="400"
                    :series="[]"
                    :options="chartOptions"
                    :range="groupBy"
                />
            </div>

        </Card>
    </div>
</template>



<script>
    import { chartDataGroupBy } from '@/utils/chart';
    import Chart from '@/components/common/Chart.vue';

    export default {
        name: 'CategoryHeatmap',
        components: {
            Chart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChartImpressions: this.$req('space/CategoryImpressionsHeatmap'),
                requestChartClicks: this.$req('space/CategoryClicksHeatmap'),
                currentChart: 'impressions',
            };
        },
        computed: {
            requestChart() {
                if (this.currentChart === 'impressions') return this.requestChartImpressions;
                if (this.currentChart === 'clicks') return this.requestChartClicks;
                return null;
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = { ...(this.timeRange || {}) };
                return { urlParams, requestParams };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartSeries() {
                if (!this.chartData[0]) return [];
                const data = this.chartData;
                const headers = data[0];
                const categories = headers.slice(1);
                const series = data.slice(1).map((row, index) => ({
                    name: row[0],
                    color: '#2e93fa',
                    data: categories.map((category, i) => ({
                        x: category,
                        y: row[i + 1],
                    })),
                }));
                return series;
            },
            chartOptions() {
                const length = this.chartData.length;
                return {
                    series: this.chartSeries,
                    chart: {
                        type: 'heatmap',
                        height: length ? length * 30 + 70 : 300,
                    },
                    xaxis: {
                        type: 'category',
                        position: 'top',
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    tooltip: {
                        enabled: false,
                    },
                    plotOptions: {
                        heatmap: {
                            colorScale: {
                                ranges: [{ from: 0, to: 100, color: '#2e93fa' }],
                            },
                        },
                    },
                    legend: {
                        show: false,
                    },
                };
            },
        },
        watch: {
            spaceId: {
                handler: 'loadData',
            },
            timeRange: {
                handler: 'loadData',
            },
            currentChart: {
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.fetchChart();
            },
            fetchChart() {
                this.requestChart.get(this.apiParams);
            },
        },
        created() {
            this.loadData();
        },
    };
</script>



<style lang="scss" scoped></style>
